import { useEffect, useLayoutEffect, useState, useRef } from "react"
import "ol/ol.css"
import Map from "ol/Map"
import View from "ol/View"
import TileLayer from "ol/layer/Tile"
import VectorLayer from "ol/layer/Vector"
import { Feature } from "ol"
import { fromLonLat } from "ol/proj"
import OSM from "ol/source/OSM"
import VectorSource from "ol/source/Vector"
import Icon from "ol/style/Icon"
import Style from "ol/style/Style"
import { Point } from "ol/geom"
import Select from "ol/interaction/Select"
import { pointerMove } from "ol/events/condition"
import { Link } from "react-router-dom"
// Import your custom hooks and types
import { useDeviceMapMutation } from "../../store/Features/devices/devicesMap-api-slice"

import { IDeviceMap, ISelectedDeviceIds } from "@types"
import { Button } from "components"
import { useSelector } from "react-redux"
export const MyMap = ({ height }: any) => {
 const [fetchDeviceMapData] = useDeviceMapMutation()
 const selectedDeviceIds: ISelectedDeviceIds = useSelector((state: any) => state.selectedDevicesIds)

 const mapRef = useRef(null)

 const modalContainerRef = useRef(null)
 const [mapData, setMapData] = useState<IDeviceMap[]>()
 const [selectedFeature, setSelectedFeature] = useState<Feature<Point> | null>(null)
 const [modalPosition, setModalPosition] = useState<{ top: number; left: number } | null>(null)

 useEffect(() => {
  fetchDeviceMapData({ deviceId: selectedDeviceIds.deviceIds })
   .then((res: any) => {
    setMapData(res.data)
   })
   .catch((e: any) => {
    console.log("e", e)
   })
 }, [selectedDeviceIds])

 useLayoutEffect(() => {
  const initialLatitude = 51.1657
  const initialLongitude = 10.4515

  const map = new Map({
   target: mapRef.current!,
   layers: [
    new TileLayer({
     source: new OSM(),
    }),
    new VectorLayer({
     source: new VectorSource({
      features: mapData?.map((device, index) => {
       const coordinates = fromLonLat([device?.device_longitude, device?.device_latitude])
       const deviceFeature = new Feature({
        geometry: new Point(coordinates),
       })

       deviceFeature.setProperties({
        id: index,
        name: `Device ${index}`,
        serverName: device?.common_information.server_name,
        deviceName: device?.common_information.device_name,
        additionalInfo: device?.additional_state_information,
        location: device?.common_information.location,
        state: device?.device_state,
        deviceId: device?.common_information.device_id,
       })

       return deviceFeature
      }),
     }),
     style: new Style({
      image: new Icon({
       src: 'data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30" fill="blue"><circle cx="12" cy="12" r="10" stroke="white" stroke-width="3" fill="black" /></svg>',
       scale: 0.5,
      }),
     }),
    }),
   ],
   view: new View({
    center: fromLonLat([initialLongitude, initialLatitude]),
    zoom: 6,
   }),
  })

  const select = new Select()

  map.addInteraction(select)

  select.on("select", (event) => {
   const selectedFeature = event.selected[0]
   if (selectedFeature) {
    const geometry = selectedFeature.getGeometry()
    if (geometry instanceof Point) {
     const coordinates = geometry.getCoordinates()
     const [x, y] = map.getPixelFromCoordinate(coordinates)
     const mapCenter = map.getSize() || [0, 0]
     const isOnLeftSide = x < mapCenter[0] / 2

     setModalPosition({
      top: y - 0,
      left: isOnLeftSide ? x + 10 : x - 325,
     })

     setSelectedFeature(selectedFeature as Feature<Point>)
    }
   } else {
    setSelectedFeature(null)
   }
  })

  const hoverSelect = new Select({
   condition: pointerMove, // Use pointerMove event to trigger on hover
  })

  map.addInteraction(hoverSelect)

  hoverSelect.on("select", (event) => {
   const hoveredFeature = event.selected[0]
   if (hoveredFeature && !select.getFeatures().getArray().includes(hoveredFeature)) {
    const geometry = hoveredFeature.getGeometry()
    if (geometry instanceof Point) {
     const coordinates = geometry.getCoordinates()
     const [x, y] = map.getPixelFromCoordinate(coordinates)
     const mapCenter = map.getSize() || [0, 0]
     const isOnLeftSide = x < mapCenter[0] / 2

     setModalPosition({
      top: y - 0,
      left: isOnLeftSide ? x + 10 : x - 325,
     })

     setSelectedFeature(hoveredFeature as Feature<Point>)
    }
   } else if (!select.getFeatures().getLength()) {
    setSelectedFeature(null)
   }
  })

  return () => {
   map.setTarget(null!)
   map.removeInteraction(select)
   map.removeInteraction(hoverSelect)
  }
 }, [mapData])

 return (
  <div className="z-10" style={{ position: "relative" }}>
   <div ref={mapRef} style={{ width: "100%", height: `${height}` }} />
   {selectedFeature && modalPosition && (
    <div
     ref={modalContainerRef}
     style={{
      position: "absolute",
      top: modalPosition.top + 0,
      left: modalPosition.left - 10,
      minWidth: "200px",
      width: "300px",
     }}
    >
     <div className="bg-white rounded shadow-lg z-50" style={{ minWidth: "230px", width: "330px" }}>
      <button
       className="absolute top-3 -right-4 text-gray-500 hover:text-gray-700 cursor-pointer"
       onClick={() => setSelectedFeature(null)}
      >
       <div className="text-white">
        <svg
         xmlns="http://www.w3.org/2000/svg"
         fill="currentColor"
         viewBox="0 0 24 24"
         stroke="currentColor"
         className="h-6 w-6"
        >
         <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M6 18L18 6M6 6l12 12"
         />
        </svg>
       </div>
      </button>
      <div className="flex items-center bg-golden rounded text-white py-2 px-4">
       <p className="text-lg font-semi "> {selectedFeature.get("serverName")}:</p>
       <h3 className="text-lg font-semi pl-1 ">{selectedFeature.get("deviceName")}</h3>
      </div>
      <div className="px-4 py-3 text-black">
       <p>{selectedFeature.get("location")}</p>
       <p>
        <span className="">State:</span>
        {selectedFeature.get("state")}
       </p>
       <p>{selectedFeature.get("additionalInfo")}</p>
       <div className="flex mt-1.5">
        <div>
         {" "}
         <Button className="text-white" size={"sm"}>
          Switch
         </Button>
        </div>
        <div className="mx-2">
         {" "}
         <Link to={`/sitePlan/?deviceId=${selectedFeature.get("deviceId")}`}>
          <Button className="text-white" size={"sm"}>
           Site plan
          </Button>{" "}
         </Link>
        </div>
        <div>
         <Link to={`/plant-status/?deviceId=${selectedFeature.get("deviceId")}`}>
          <Button className="text-white" size={"sm"}>
           State
          </Button>{" "}
         </Link>
        </div>
       </div>
      </div>
     </div>
    </div>
   )}
  </div>
 )
}
